var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"link",on:{"click":_vm.openModalAction}},[_c('img',{attrs:{"src":"/images/icn_delete.svg"}}),_c('span',[_vm._v("キッズ削除")])])])}
var staticRenderFns = []

export { render, staticRenderFns }